import React, { Component } from "react";
import produce from "immer";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import _ from "lodash";
import ModifyCCode from "./ModifyCCode";
const qs = require("query-string");

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cCode: ""
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const params = qs.parse(this.props.location.search);
    const { cCode: cCodeParams } = params;
    const { cCode } = this.state;

    if (cCodeParams !== cCode) {
      this.setState(
        produce(draft => {
          draft.cCode = cCodeParams;
        })
      );
    }
  }

  renderRow = (cCode, users) => {
    return (
      <table className="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">이름</th>
            <th scope="col">이메일</th>
            <th scope="col">클래스코드 수정</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(users)
            .filter(([uid, user]) => user.currentClass === cCode)
            .sort(([uid1, user1], [uid2, user2]) =>
              user1.name < user2.name ? -1 : 1
            )
            .map(([uid, user], idx) => (
              <tr key={idx}>
                <th scope="row">{idx + 1}</th>
                <td>{user.name}</td>
                <td>{user.email || "n/a"}</td>
                <td>
                  <ModifyCCode uid={uid} cCodeDefault={cCode} />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };

  render() {
    const params = qs.parse(this.props.location.search);
    const { cCode: cCodeParam } = params;
    const { users } = this.props;

    if (cCodeParam === undefined) {
      return false;
    }

    return !_.isEmpty(users) && cCodeParam ? (
      <div className="row">
        <div className="col-12">{this.renderRow(cCodeParam, users)}</div>
      </div>
    ) : (
      false
    );
  }
}

const mapStateToProps = state => ({
  users: state.users
});

export default withRouter(connect(mapStateToProps)(List));
